import type { FC } from 'react';

import { useIsSellerCommunicationsAllowed } from 'Features/SellerCommunications/hooks/useIsSellerCommunicationsAllowed';

import { ModalTrigger } from '../ModalTrigger';

export const SellerCommunicationsButton: FC = () => {
	const isAllowed = useIsSellerCommunicationsAllowed();
	return isAllowed ? <ModalTrigger /> : null;
};
